// src/Components/TopBar/QuickLinkButton.tsx
import React from 'react';

export interface QuickLinkButtonProps {
  href: string;
  label: string;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

export default function QuickLinkButton({
  href,
  label,
  Icon,
}: QuickLinkButtonProps) {
  return (
    <div className="tooltip-wrapper">
      {/* anchor = native link → new tab */}
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label} /* screen-reader text */
        className="relative w-8 h-8 rounded-full flex items-center justify-center cursor-pointer shadow button-wrapper"
      >
        <Icon className="w-5 h-5 text-green" />
      </a>
      <span className="tooltip-text">{label}</span>
    </div>
  );
}
